import PropTypes from "prop-types";
import React from "react";
import Modal from "react-bootstrap/Modal";

const AdditionalDetailsLongTextDialog = ({ label, value, onClose }) => (
  <Modal show onHide={onClose} scrollable aria-label={label}>
    <Modal.Header closeButton>
      <Modal.Title>{label}</Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
      {value}
    </Modal.Body>
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-secondary"
        onClick={onClose}
        aria-label="Close full text"
      >
        Close
      </button>
    </Modal.Footer>
  </Modal>
);

AdditionalDetailsLongTextDialog.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default AdditionalDetailsLongTextDialog;
